module.exports = __webpack_public_path__ + "img/24_40.1083956f.png";